var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"float_button"},[_c('div',{ref:"floatButton",staticClass:"float_info",style:({
      width: _vm.itemWidth + 'px',
      height: _vm.itemHeight + 'px',
      left: _vm.left + 'px',
      top: _vm.top + 'px'
    }),on:{"click":_vm.onBtnClicked}},[_c('img',{attrs:{"src":"minio/gyfw/school/myddc.png","alt":"","srcset":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }